import pdfMake from 'pdfmake/build/pdfmake';
import { vfs } from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = vfs;

const getTextMaxWidth = (content = {}) => {
  const temp = [];
  temp.push(content);
  const pdf = pdfMake.createPdf({ content: temp });
  pdf.getStream({});
  return pdf.docDefinition.content[0]._maxWidth;
};

export const truncateText = (text, options) => {
  const { maxWidth, fontSize } = options;
  const { length } = text || '';
  let b = length;
  const trunc = (len) => {
    len = Math.max(Math.round(len), 1);
    return len < length ? `${text.slice(0, len - 1)}…` : text;
  };
  const f = (len) =>
    getTextMaxWidth({
      text: trunc(len),
      fontSize,
    }) - maxWidth;

  let bx = f(b);
  if (bx > 0) {
    let a = 0,
      ax = f(0);
    if (ax >= 0) return '…';
    if (Math.abs(ax) < Math.abs(bx)) [a, ax, b, bx] = [b, bx, a, ax];
    const xTol = 1;
    let c = a,
      cx = ax,
      mflag = true,
      d,
      maxIter = 20;
    while (maxIter-- && Math.abs(b - a) > xTol) {
      const acx = ax - cx;
      const bcx = bx - cx;
      const abx = ax - bx;
      let s =
        Math.abs(acx) > Number.EPSILON && Math.abs(bcx) > Number.EPSILON
          ? (a * bx * cx) / (abx * acx) +
            (b * ax * cx) / (-abx * bcx) +
            (c * ax * bx) / (acx * bcx)
          : b - (bx * (b - a)) / (bx - ax);
      if (
        s < (3 * a + b) / 4 ||
        s > b ||
        (mflag
          ? Math.abs(s - b) >= Math.abs(b - c) / 2 ||
            Math.abs(b - c) < Math.abs(2 * Number.EPSILON * Math.abs(b))
          : Math.abs(s - b) >= Math.abs(c - d) / 2 ||
            Math.abs(c - d) < Math.abs(2 * Number.EPSILON * Math.abs(b)))
      ) {
        s = (a + b) / 2;
        mflag = true;
      } else {
        mflag = false;
      }
      const sx = f(s);
      [d, c, cx] = [c, b, bx];
      if (ax * sx < 0) [b, bx] = [s, sx];
      else [a, ax] = [s, sx];
      if (Math.abs(ax) < Math.abs(bx)) [a, ax, b, bx] = [b, bx, a, ax];
    }
    return trunc(ax < bx ? a : b);
  }

  return text;
};
